import { PwWebConection } from '../types';
import { ConnectionsApi } from '../apis';

interface ConnectionCache {
  connections: { [projectId: string]: PwWebConection[] };
}

const connectionCache: ConnectionCache = {
  connections: {},
};

export async function getConnections(projectId: string) {
  if (connectionCache.connections[projectId]) {
    return connectionCache.connections[projectId];
  }

  const connections = await ConnectionsApi.fetchConnections(projectId);
  connectionCache.connections[projectId] = connections;
  return connections;
}
